import React from "react";
import {Field, reduxForm} from 'redux-form'
import {Button, Col, Form, FormGroup} from "react-bootstrap";
import {QuillEditor} from "components/common";
import {isObjectEmpty} from "_helpers";
import styles from "../Styles.module.css";
import BasicFilterSelect from "../../v2/common/BasicFilterSelect";

const CompanyUpdatesAddForm = ({ handleSubmit, organizations, createUpdate, handleOrganizationSelect}) => {

    return (
        <div className={`container-pane container-pane-expert-page`}>
            <div >
                <Form onSubmit={handleSubmit(createUpdate)} horizontal className="margin-top-50">
                    <FormGroup className="form-row">
                        <Col className={`inbox-context-menu display-block ${styles["w23"]}`}>
                            <BasicFilterSelect
                                placeholder={'Select organization'}
                                options={organizations}
                                onChange={handleOrganizationSelect}
                                listBoxHeight={380}
                            />

                        </Col>
                    </FormGroup>

                    <FormGroup className="form-row">
                        <Col className={`inbox-context-menu display-block  ${styles["w21"]}`}>
                            <Field
                                className="with-border margin-bottom-15 margin-top-15 padding-top-20 padding-bottom-20 form-control"
                                required={true}
                                component="input"
                                type="text"
                                name="summary"
                                placeholder="Summary"
                            />
                        </Col>
                    </FormGroup>


                    <FormGroup className="form-row">
                        <Col className={styles.w70}>
                            <Field
                                name="description"
                                type="textarea"
                                defaultText=""
                                component={QuillEditor}
                                className="form-control"
                                rows={10}
                                useWithRedux={true}
                                required={true}
                            />
                        </Col>
                    </FormGroup>

                    <FormGroup className={`-align-left text-right margin-top-15  ${styles["w72"]}`}>
                        <Button type="submit" className={`btn btn-success font-15`}>Create Notification</Button>
                    </FormGroup>
                </Form>
            </div>
        </div>
    )
}


const connectedComponent =  reduxForm({
    form: 'chatdeskUpdatesForm',
})(CompanyUpdatesAddForm);

export {connectedComponent as CompanyUpdatesAddForm}